import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  GetExternalGroupListDocument,
  GetGroupListDocument,
  Group_Connection,
  type GetExternalGroupListQuery,
  type GetGroupListQuery,
} from "@/graphql/generated-types";

const getGroups = async (): Promise<GetGroupListQuery> => {
  const response = await graphqlClient.query({
    query: GetGroupListDocument,
  });

  if (response.data.institutions?.getMyInstitution.groups) {
    return response.data;
  }

  throw new SentryGraphQLError("groups.getGroups");
};

const getExternalGroups = async (
  type: Group_Connection,
): Promise<GetExternalGroupListQuery> => {
  const response = await graphqlClient.query({
    query: GetExternalGroupListDocument,

    variables: {
      type,
    },
  });

  if (response.data.institutions?.getMyInstitution.externalGroups) {
    return response.data;
  }

  throw new SentryGraphQLError("groups.getExternalGroups");
};

export default {
  getGroups,
  getExternalGroups,
};
